import { useContainerWidth } from "Hooks";
import React, { memo, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { getDataGridHeaders } from "../../modules/utils";
import { DataGrid } from "@toddle-edu/ds-data-grid";
import classes from "./GradeLevelsSkeleton.scss";
import { DATA_GRID_CELL_TYPES } from "../../modules/constants";
import _ from "lodash";
import { useGradeLevelsContext } from "../../context";
import { getCurrentColumns } from "../../modules/utils/dataGridHelpers";

const GradeLevelsSkeleton = () => {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const containerWidth = useContainerWidth({ containerRef });

  const { isEditMode } = useGradeLevelsContext();

  const columns = useMemo(() => getCurrentColumns({ isEditMode }), [
    isEditMode,
  ]);

  const headers = useMemo(
    () =>
      getDataGridHeaders({ t, parentContainerWidth: containerWidth, columns }),
    [containerWidth, t, columns]
  );

  const data = useMemo(
    () =>
      _.times(10, index => ({
        rowId: `row-${index}`,
        columns: _.map(headers, () => ({
          cellType: DATA_GRID_CELL_TYPES.SKELETON,
        })),
      })),
    [headers]
  );

  return (
    <div ref={containerRef} className={classes.container}>
      <DataGrid
        data={data}
        headers={headers}
        rowMarkers="none"
        columnsResizable={false}
        blurSelectionOnOutsideClick
        dataGridHeight="100%"
      />
    </div>
  );
};

export default memo(GradeLevelsSkeleton);
